

export function getErrText(errclass, data) {
    if (errclass === "error") {
        return 'Error'
    } else {
        return data
    }
}


export function getErrColor(errclass) {
    if (errclass === "red" || errclass === "error") {
        return 'text-danger'
    } else {
        return ''
    }
}

export function createdata_row(tagstate, data, cod_bit) {
    var err_color_style = ""
    if (tagstate !== "" && (tagstate !== "red" || tagstate !== "error")) {
        err_color_style = 'item text-danger'
    } else {
        err_color_style = 'item '
    }
    if (cod_bit === false) {
        err_color_style += " CODColor"
    }
    var data_view = ""
    if (tagstate === "error") {
        data_view = 'Error'
    } else {
        data_view = data
    }
    return <td align="right" className={err_color_style}>{data_view}</td>
}